module.exports = __webpack_public_path__ + "img/18.20b469ab.jpg";